module.exports = __webpack_public_path__ + "static/media/new-index-logo.cd694d94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/eztrader/new-index-logo.svg
// module id = 1245
// module chunks = 103